module.exports = __webpack_public_path__ + "img/ad3.d0f60214.png";